/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileCertification } from '../../models/profile-certification';

export interface UpdateProfileCertification$Params {

/**
 * ID of profile to which will be certification add
 */
  id: number;

/**
 * Profile certification type (ProfileCertificationType).
 */
  type: string;

/**
 * Profile certification year.
 */
  year: number;
  
    /**
     * ProfileProfile certification to update.
     */
    body: ProfileCertification
}

export function updateProfileCertification(http: HttpClient, rootUrl: string, params: UpdateProfileCertification$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileCertification>> {
  const rb = new RequestBuilder(rootUrl, updateProfileCertification.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('type', params.type, {});
    rb.path('year', params.year, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileCertification>;
    })
  );
}

updateProfileCertification.PATH = '/rest/profile/{id}/certification/{type}/{year}';
